
/*==========================================================
SUB NAV
==========================================================*/
$(function() {

    // Hide Mobile subNav trigger if subnav is empty
    if (!$('#subNavWrapper #subNavContainer .subNav li').first().children().length) {
        $('.subNavTrigger').addClass('hide');
    } else {
        $('.subNavTrigger').removeClass('hide');
    }

    // Mobile subNav open/close
    $('.subNavTrigger').on('click', function(event) {
        event.preventDefault();
        $('#subNavWrapper').slideToggle();
        $(this).toggleClass('is-active');
        var triggerText = $(this).find('.triggerText');

        if (!$(this).hasClass('is-active')) {
            if (iCreateObject.lang === 'fr') {
                triggerText.html('Menu');
            } else {
                triggerText.html('Menu');
            }
        } else {
            if (iCreateObject.lang === 'fr') {
                triggerText.html('Fermer');
            } else {
                triggerText.html('Close');
            }
        }
        let isExpanded = $(this).attr('aria-expanded') === 'true' ? false : true;
        $(this).attr('aria-expanded', isExpanded ? 'true' : 'false');
    });

    // Subnav Extended Menu Toggle Click
    $('#subNavWrapper .showAllWrapper').on('click', 'a.extendedMenu, .extendedMenuWrapper > div[role="button"]', function(event) {
        event.preventDefault();
        extendedNavToggle($(this));
    });

    // Subnav Extended Menu Toggle Keyboard
    $('#subNavWrapper .showAllWrapper').on('keyup', 'div[role="button"]', function(event) {
        var code = event.keyCode || event.which;
        if (code === 13) { //Enter keycode
            extendedNavToggle($(this));
        }
    });

    // Subnav Extended Menu Toggle
    function extendedNavToggle(element) {
        //show/hide menu items
        let isExpanded = element.attr('aria-expanded') === 'true' ? false : true;
        element.attr('aria-expanded', isExpanded ? 'true' : 'false');

        element
        .parent('div')
        .next('ul')
        .parent('li')
        .toggleClass('open');

    }

    // Subnav Menu Toggle Click
    $('.subNav').on('click', 'div[role="button"]:not(.extendedToggle)', function(event) {
        event.preventDefault();
        event.stopPropagation();
        subNavToggle($(this));
    });

    // Subnav Menu Toggle Keyboard
    $('.subNav').on('keyup', 'div[role="button"]:not(.extendedToggle)', function(event) {
        var code = event.keyCode || event.which;
        if (code === 13) { //Enter keycode
            subNavToggle($(this));
        }
    });

    // Subnav Menu Toggle
    function subNavToggle(element) {
        let isExpanded = element.attr('aria-expanded') === 'true' ? true : false;
        element.attr('aria-expanded', isExpanded ? 'false' : 'true');
        element
            .next('ul')
            .stop()
            .slideToggle()
            .parent('li')
            .toggleClass('open');
    }
});
